const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/ECheckinForm.tsx';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from './translations';
import ECheckinSections from 'App/components/eCheckin/components/ECheckinSections';
import PersAngaben from 'App/config/soh/eCheckin/sections/PersAngaben';
import KontaktPerson from 'App/config/soh/eCheckin/sections/KontaktPerson';
import HausArzt from 'App/config/soh/eCheckin/sections/HausArzt';
import ZuweisenderArzt from 'App/config/soh/eCheckin/sections/ZuweisenderArzt';
import Versicherung from 'App/config/soh/eCheckin/sections/Versicherung/Versicherung';
import Abschluss from 'App/config/soh/eCheckin/sections/Abschluss';
import Finalize from 'App/components/eCheckin/components/sections/Finalize';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { makeSelectCIS4m } from '@cistec/common_web/modules/CIS4m/store';
import { useMadeSelector } from '@cistec/common_web/utils/store';

export const ECheckinForm = forwardRef((_props: {}, ref) => {
    const eCheckinSectionsRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();
    const cis4mData = useMadeSelector(() => makeSelectCIS4m(formId), [formId]);
    if (!cis4mData) return null;

    return (
        <ECheckinSections ref={eCheckinSectionsRef} cis4mData={cis4mData}>
            <PersAngaben path="persAngaben" title={textMap.persAngaben} />
            <KontaktPerson path="kontakt" title={textMap.kontakt} />
            <HausArzt path="hausArzt" title={textMap.hausArzt} />
            <ZuweisenderArzt path="zuweisenderArzt" title={textMap.zuweisenderArzt} />
            <Versicherung path="versicherungUndZusatzleistung" title={textMap.versicherungUndZusatzleistung} />
            <Abschluss path="abschluss" title={textMap.abschluss} />
            <Finalize path={'finalize'} />
        </ECheckinSections>
    );
});

ECheckinForm.displayName = 'ECheckinForm';

export default ECheckinForm;
